module.exports = __webpack_public_path__ + "static/infringement-issues-trademark2-2a14ab57968000eb66a1d436dea5396d.png";